<template>
  <select :value="value" @change="onDataChanged($event.target.value)">
    <option v-if="all" value="">{{ $t('sdl.common.label.all') }}</option>
    <option v-else-if="select" value="">{{ $t('sdl.common.label.select') }}</option>
    <option v-for="code in codeList" :key="code.codeId" :value="code.code">{{ getLabel(code) }}</option>
  </select>
</template>

<script>
import { SDLUtil } from '@/utils';
import SDLLocale from '@/mixin/SDLLocale';

export default {
  mixins: [SDLLocale],
  props: {
    codeCondition: {},
    value: {
      default: null,
    },
    all: {
      type: Boolean,
      default: false,
    },
    select: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      validCodeList: SDLUtil.getCommCodeList({ commCodeTypeId: 'VALID-CODE-MENU' }),
    };
  },
  computed: {
    menuId() {
      return this.$route.meta.menuId;
    },
    pageId() {
      return this.$route.meta.pageId;
    },
    menuValidCode() {
      return this.validCodeList.find(code => code.code === this.pageId || code.code === this.menuId);
    },
    validCodes() {
      if (this.menuValidCode) return this.validCodeList.filter(code => code.upperCodeId === this.menuValidCode.codeId);
      return [];
    },
    codeList() {
      if (this.validCodes) {
        const codeList = SDLUtil.getCommCodeList(this.codeCondition);
        const result = [];
        for (let i = 0; i < codeList.length; i += 1) {
          if (!this.validCodes.find(valCode => valCode.code === codeList[i].codeId && valCode.description === 'HIDE')) result.push(codeList[i]);
        }
        return result;
      }
      return SDLUtil.getCommCodeList(this.codeCondition);
    },
  },
  methods: {
    onDataChanged(value) {
      if (value) {
        const selectedCode = this.codeList.find(code => code.code === value);
        const oldVal = this.value;
        if (this.validCodes.find(valCode => valCode.code === selectedCode.codeId)) {
          this.$emit('input', value);
          SDLUtil.alert({
            msg: this.$t('cop.valid-code-menu.alert', [this.getLabel(selectedCode)]),
            onOkEvt: () => {
              this.$emit('input', oldVal);
            },
          });
        } else {
          this.$emit('input', value);
          this.$emit('change');
        }
      } else {
        this.$emit('input', value);
        this.$emit('change');
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/code/CodeSelect.vue